import { FINISHED_PACKING_FAILED, FINISHED_PACKING_REQUEST, FINISHED_PACKING_SUCCESS } from "../../../actions/Packing/finishedReadyforPacking/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const finishedReadyPackingReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case FINISHED_PACKING_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case FINISHED_PACKING_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case FINISHED_PACKING_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
